import { useEffect, useState, useContext,  useMemo} from 'react'; // useMemo pour Table.jsx
import { useNavigate, NavLink } from "react-router-dom";

import { DonneesUtilisateurContext } from '../contexte.js';
import '../config.js';

import LoadingSpinner from "../Components/LoadingSpinner.js";
import CsvDownloader from "../Components/CsvDownloader.jsx";



/**
 * Return Page avec des liens
 *
 * @component
 * @summary pour affichage liste de liens
 * @param {  }
 * @return { HTMLElement }
*/
function AdmListes() {
    const { setBearer, utilisateurRouteLogin, utilisateurBearer, utilisateurRole } = useContext(DonneesUtilisateurContext);
    const navigate = useNavigate(); // utile pour changer de page
    const [dataLoaded, setDataLoaded] = useState(false);
    const [messageProbleme, setMessageProbleme] = useState('');


    async function chargementsConsecutifs() {
        setDataLoaded(true);
    }
    

    useEffect(() => {
        if(global.config.modeDebugApp == 1) console.log('useffect 1st');
        document.title = "Quiforme : listes des introuvables"
        if (utilisateurBearer === '000000' || utilisateurRole != "AdminExtranet" )  navigate(utilisateurRouteLogin); // si pas identifié ou role NOK on redirige sur l'acceuil
        chargementsConsecutifs();
    }, []);


   return (     
        <main className="sous-bloc">
            <LoadingSpinner dataLoaded={dataLoaded} />

            { dataLoaded > 0 &&
            <>
                {/*
                <NavLink className="main-nav-item" style={{textDecoration: "underline"}} target='blank'
                         to={process.env.REACT_APP_API_URL + "/liste-html?what=logs-mail"}>cliquant ici</NavLink> */}
                <CsvDownloader urlApi="/liste-csv?what=logs-mail" boutonLib="Télécharger cette liste au format CSV" boutonTitle="Liste des mails envoyés par l'extranet"
                               nomFicCible="Liste_mails_envoyes_extranet" sizeFontBt="1.1rem" />
            </> } 
        </main>
    )
}


export default AdmListes;